import { useTranslation } from "react-i18next";

import type { Patient } from "~/api/patients";
import { Card } from "~/ui";
import { calculateAge } from "~/utils";
import { getPatientInitials } from "~/utils/getPatientInitials";
import { PersonalInformation } from "./components";

interface PatientPersonalInformationProps {
  patient: Patient;
}

export const PatientPersonalInformation = ({
  patient,
}: PatientPersonalInformationProps) => {
  const { t } = useTranslation();

  const patientAge = calculateAge(patient.date_of_birth);

  return (
    <Card className="col-span-1 flex h-full justify-between bg-gradient-to-b from-surface-container-high to-surface-container-low p-5 text-neutral-900 shadow-sm dark:from-surface-container-high-dark dark:to-surface-container-low-dark dark:text-white md:col-span-2">
      <div className="items-top flex justify-between gap-5">
        <div className="align-center flex flex-col gap-2 text-center">
          <PersonalInformation.Icon icon={getPatientInitials(patient)} />
          <h5 className="text-xl text-neutral-900 dark:text-white">
            {patient.name} {patient.surname}
          </h5>
        </div>
        <Card className="col-span-2 bg-surface-container text-neutral-variant-50 hover:bg-surface-container dark:text-neutral-variant-70">
          <PersonalInformation.Input>
            <PersonalInformation.ContentTitle>
              {t("patient_detail.unit")}:
            </PersonalInformation.ContentTitle>
            {patient.unit && (
              <PersonalInformation.Content>
                {patient.unit.name}
              </PersonalInformation.Content>
            )}
          </PersonalInformation.Input>
          <PersonalInformation.Input>
            <PersonalInformation.ContentTitle>
              {t("patient_detail.age")}:
            </PersonalInformation.ContentTitle>
            {patient.unit && (
              <PersonalInformation.Content>
                {patientAge.toString()}
              </PersonalInformation.Content>
            )}
          </PersonalInformation.Input>
          <PersonalInformation.Input>
            <PersonalInformation.ContentTitle>
              {t("patient_detail.email")}:
            </PersonalInformation.ContentTitle>
            {patient.unit && (
              <PersonalInformation.Content>
                {patient.email}
              </PersonalInformation.Content>
            )}
          </PersonalInformation.Input>
        </Card>
      </div>
    </Card>
  );
};
